import { createHttpError } from '@wix/http-client';

export async function createHttpErrorFromFetch(originalResponse: Response) {
  const res = originalResponse.clone();

  return createHttpError({
    name: 'Error',
    message: `Request failed with status code ${res.status}`,
    response: {
      config: {},
      data: await res.text(),
      status: res.status,
      statusText: res.statusText,
      headers: Object.fromEntries(res.headers as never),
    },
    code: res.statusText,
    config: {},
    toJSON: () => res,
    __CANCEL__: false,
  });
}
